import React from "react";
import { Calendar } from "lucide-react";
import Badge from "../../../components/common/Badge";
import NoDataFound from "../../../components/common/NoDataFound";
import { useEntitySettings } from "../../../contexts/EntitySettingsContext";
import { statusVariant } from "../../../utils/statusVariant";

interface Task {
  id: number;
  type: string;
  title: string;
  dueDate: string;
  status: string;
  priority: string;
  context: string;
  description: string;
  createdBy?: string;
  createdOn?: string;
}

interface PlanDeadlinesNetBodyProps {
  tasks: Task[];
}

const StatusBadge = ({ status }: { status: string }) => (
  <Badge variant={statusVariant(status)} size="sm">{status}</Badge>
);

const PlanDeadlinesNetBody: React.FC<PlanDeadlinesNetBodyProps> = ({
  tasks,
}) => {
  const { formatDate } = useEntitySettings();
  const fmtDate = (d?: string) => {
    if (!d) return "";
    return formatDate(d);
  };
  return (
    <div className="netbody-card flex flex-col h-full min-h-[500px]">
      <div className="netbody-content">
        <div className="scroll-container-nofilters flex-1 overflow-hidden">
          {tasks.length === 0 ? (
            <NoDataFound
              title="No Deadlines"
              message="Tasks with due dates assigned to you in this entity will appear here."
            />
          ) : (
          <div className="space-y-3 py-2">
            {tasks.map((task) => (
              <div key={task.id} className="deadline-task-card">
                <div className="deadline-task-content">
                  <Calendar className="deadline-task-icon" />
                  <div className="deadline-task-meta">
                    <h4 className="deadline-task-title">{task.title}</h4>
                    <p className="deadline-task-description">
                      {task.context} • {task.description}
                    </p>
                    {(task.createdBy || task.createdOn) && (
                      <p className="deadline-task-description" style={{ marginTop: 4, opacity: 0.8 }}>
                        {task.createdBy ? `Created by ${task.createdBy}` : ""}
                        {task.createdBy && task.createdOn ? " • " : ""}
                        {task.createdOn ? fmtDate(task.createdOn) : ""}
                      </p>
                    )}
                  </div>
                </div>
                <div className="deadline-task-info">
                  <span className="deadline-task-date">{fmtDate(task.dueDate)}</span>
                  <StatusBadge status={task.status} />
                </div>
              </div>
            ))}
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlanDeadlinesNetBody;
